// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"51795053","247":"7f9d64db","513":"50445d84","706":"711ede07","726":"759a3e6d","881":"e66cd213"}[chunkId] + ".chunk.js";
};